import {useEffect, useRef} from "react";
import {useLocation} from "react-router";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeFlow, isRegistrationWizardStepShown} from "../state/registration_flow_slice";
import {trackRegistrationWizardPhoneAbandoned} from "../tracking/track_registration_wizard_events";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {useRegistrationWizardTrackingContext} from "./use_registration_wizard_tracking_context";

export const useCloseRegistrationFlowOnRouteChange = () => {
    const {pathname} = useLocation();
    const dispatch = useAppDispatch();
    const isWizardStepShown = useAppSelector((state) => isRegistrationWizardStepShown(state.registrationFlow));
    const currentStep = useAppSelector((state) => state.registrationFlow.currentStep);
    const trackingContext = useRegistrationWizardTrackingContext();
    const previousPathnameRef = useRef(pathname);

    useEffect(() => {
        if (previousPathnameRef.current === pathname) {
            return;
        }

        previousPathnameRef.current = pathname;

        if (!isWizardStepShown) {
            return;
        }

        if (currentStep === RegistrationFlowStep.PHONE_VERIFICATION) {
            trackRegistrationWizardPhoneAbandoned(trackingContext);
        }

        dispatch(closeFlow());
    }, [pathname]);
};
import {useEffect, useRef} from "react";
import {useLocation} from "react-router";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeFlow, isRegistrationWizardStepShown} from "../state/registration_flow_slice";
import {trackRegistrationWizardPhoneAbandoned} from "../tracking/track_registration_wizard_events";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {useRegistrationWizardTrackingContext} from "./use_registration_wizard_tracking_context";

export const useCloseRegistrationFlowOnRouteChange = () => {
    const {pathname} = useLocation();
    const dispatch = useAppDispatch();
    const isWizardStepShown = useAppSelector((state) => isRegistrationWizardStepShown(state.registrationFlow));
    const currentStep = useAppSelector((state) => state.registrationFlow.currentStep);
    const trackingContext = useRegistrationWizardTrackingContext();
    const previousPathnameRef = useRef(pathname);

    useEffect(() => {
        if (previousPathnameRef.current === pathname) {
            return;
        }

        previousPathnameRef.current = pathname;

        if (!isWizardStepShown) {
            return;
        }

        if (currentStep === RegistrationFlowStep.PHONE_VERIFICATION) {
            trackRegistrationWizardPhoneAbandoned(trackingContext);
        }

        dispatch(closeFlow());
    }, [pathname]);
};
